module.exports = __webpack_public_path__ + "57181b9a84e30b320a3c48ed97a64430.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/scarf-lines-blue.png
// module id = 1374
// module chunks = 0